/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReadOnlyWhiteLabel
 */
export interface ReadOnlyWhiteLabel {
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyWhiteLabel
     */
    id?: string;
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyWhiteLabel
     */
    client: number;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyWhiteLabel
     */
    template: string;
}

export function ReadOnlyWhiteLabelFromJSON(json: any): ReadOnlyWhiteLabel {
    return ReadOnlyWhiteLabelFromJSONTyped(json, false);
}

export function ReadOnlyWhiteLabelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReadOnlyWhiteLabel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'client': json['client'],
        'template': json['template'],
    };
}

export function ReadOnlyWhiteLabelToJSON(value?: ReadOnlyWhiteLabel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'client': value.client,
        'template': value.template,
    };
}


